module.exports = __webpack_public_path__ + "img/Netherlands.81d4445a.png";